import { getSearchString } from "../helpers/search/search.qwik.mjs";
import { isBrowser } from "./is-browser.qwik.mjs";
function isPreviewing(_search) {
  const search = _search || (isBrowser() ? window.location.search : void 0);
  if (!search)
    return false;
  const normalizedSearch = getSearchString(search);
  return Boolean(normalizedSearch.indexOf("builder.preview=") !== -1);
}
export {
  isPreviewing
};
